export default {"src":"/_next/static/media/favicon.b6b8322a.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};